import { RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { createRouter } from "./router"
import "@/styles.css"

const router = createRouter()
const rootElement =
	document.getElementById("root") ?? document.createElement("div")

createRoot(rootElement).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
)
